import React, { useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SuccessModal: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('payments');
  const dialogRef = useRef<HTMLDialogElement>(null);
  const { agentId } = useParams();

  useEffect(() => {
    if (dialogRef.current) {
      dialogRef.current.showModal();
    }
  }, []);

  const handleClose = () => {
    if (dialogRef.current) {
      dialogRef.current.close();
    }
    navigate(`/agent/${agentId}/billing`);
  };

  return (
    <dialog ref={dialogRef} className="modal">
      <div className="modal-box">
        <h2 className="mb-4 text-xl font-bold">
          {t('payment_success_title', 'Payment Successful!')}
        </h2>
        <p className="mb-6 text-center">
          {t(
            'payment_success_message',
            'Your payment was processed successfully. Thank you for your subscription!',
          )}
        </p>
        <div className="modal-action">
          <form method="dialog">
            <button
              className="btn btn-primary w-full rounded-full"
              onClick={handleClose}
            >
              {t('close', 'Close')}
            </button>
          </form>
        </div>
      </div>
      <form method="dialog" className="modal-backdrop" onClick={handleClose}>
        <button aria-label="close" />
      </form>
    </dialog>
  );
};

export default SuccessModal;
